var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip is-tooltip-bottom",attrs:{"data-tooltip":_vm.tooltip}},[_c('span',{staticClass:"fa fa-tags icon",class:_vm.statusClass})])}
var staticRenderFns = []

export { render, staticRenderFns }